<template>
  <div class="home">
    <Room artistID='jq' loadImmediate="true"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Room from '@/components/Room';

export default {
  name: "JeanneQuinn",
  components: {
    Room
  },

  methods : {

    init() {
      console.log('JEANNE QUINN')
      this.$store.commit('setArtist', this.selected);
      this.$store.commit('hide', 'gallery');
      this.$store.commit('show', 'room');
    }
  }
};
</script>
